// modules
import { find, findIndex, get } from 'lodash'
import { createSelector } from 'reselect'

import { userUuid$ } from 'src/store/modules/user'

import { NO_ASSIGNED_TO } from 'src/constants'
// utils
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

const urgentCare = (state) => state.actions.urgentCare

export const waitingRoomList$ = createSelector(
  urgentCare,
  ({ waitingRoomList }) => waitingRoomList
)

export const waitingRoomLoading$ = createSelector(
  urgentCare,
  ({ waitingRoomLoading }) => waitingRoomLoading
)

export const urgentCareCount$ = createSelector(
  urgentCare,
  ({ urgentCareCount }) => urgentCareCount
)

export const urgentCareUsersList$ = createSelector(
  urgentCare,
  ({ urgentCareUsersList }) =>
    urgentCareUsersList.map((item) => ({
      ...item,
      title: item.fullName,
      value: item.uuid,
      key: item.uuid,
      searchField: item.fullName
    }))
)

export const urgentCareUsersListWithAll$ = createSelector(
  urgentCareUsersList$,
  (urgentCareUsersList = []) =>
    addAllValue(urgentCareUsersList, true, 'All users')
)

export const urgentCareUsersListWithAllAndNoAssignee$ = createSelector(
  urgentCareUsersList$,
  (urgentCareUsersList = []) =>
    addAllValue([...urgentCareUsersList, NO_ASSIGNED_TO], true, 'All users')
)

export const urgentCareUsersListWithAllv5$ = createSelector(
  urgentCareUsersList$,
  (urgentCareUsersList = []) => addAllValueV5({ list: urgentCareUsersList })
)

export const urgentCareDeclineReasons$ = createSelector(
  urgentCare,
  ({ urgentCareDeclineReasons }) =>
    urgentCareDeclineReasons.map((item) => ({
      ...item,
      title: item.reason,
      value: item.uuid,
      key: item.uuid
    }))
)

export const urgentCareUsersOnDuty$ = createSelector(
  urgentCare,
  (urgentCare = {}) => get(urgentCare, ['urgentCareUsersOnDuty'], [])
)

export const urgentCareUsersOnDutyCount$ = createSelector(
  urgentCareUsersOnDuty$,
  (urgentCareUsersOnDuty = []) => get(urgentCareUsersOnDuty, ['length'], 0)
)

export const isUserOnDuty$ = createSelector(
  urgentCareUsersOnDuty$,
  userUuid$,
  (urgentCareUsersOnDuty = [], userUuid = null) => {
    let isUserOnDuty = findIndex(urgentCareUsersOnDuty, { uuid: userUuid })
    isUserOnDuty = isUserOnDuty !== -1

    return isUserOnDuty
  }
)

export const currentUserOnDutyEntry$ = createSelector(
  urgentCareUsersOnDuty$,
  userUuid$,
  (urgentCareUsersOnDuty = [], userUuid = null) =>
    find(urgentCareUsersOnDuty, { uuid: userUuid }) || null
)

// New queue joins always start Available (isAvailable defaults to true when
// the current user isn't found on duty, which only matters transiently
// before the on-duty list loads, since the tag is hidden unless isUserOnDuty$
// is true)
export const isUserAvailable$ = createSelector(
  currentUserOnDutyEntry$,
  (currentUserOnDutyEntry) =>
    currentUserOnDutyEntry ? currentUserOnDutyEntry.isAvailable !== false : true
)
